module.exports = __webpack_public_path__ + "static/media/upload-512.dd905077.png";